import { Box, Card, Flex } from '@auviknetworks/iceberg-ui';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Logo } from 'application/Shared/Components/App';
import { format } from 'date-fns';
import { useTenantInfoByTenantId } from 'hooks/redux/Selectors/tenants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const formatDate = (timestamp: number) =>
    format(new Date(timestamp), 'MMMM d, yyyy');

const ReportMetaEntry = ({
    label,
    value
}: {
    label: string;
    value: string;
}) => (
    <Flex sx={{ alignItems: 'center', padding: '4px 0' }}>
        <Typography sx={{ fontWeight: 600, minWidth: '120px' }} variant="body1">
            {label}:
        </Typography>
        <Typography variant="body1">{value}</Typography>
    </Flex>
);

const ReportMeta = ({
    startDate,
    endDate
}: {
    startDate: number;
    endDate: number;
}) => {
    const { t } = useTranslation();
    const { partnerId, clientId } = useParams();
    const tenantInfo = useTenantInfoByTenantId(clientId || partnerId);

    const tenantName = tenantInfo?.tenant?.name;

    return (
        <Box>
            <ReportMetaEntry
                label={t('Report.Header.createdOn')}
                value={formatDate(new Date().getTime())}
            />
            <ReportMetaEntry
                label={t('Report.Header.period')}
                value={`${formatDate(startDate)} - ${formatDate(endDate)}`}
            />
            {tenantName && (
                <ReportMetaEntry
                    label={t('Report.Header.preparedFor')}
                    value={tenantName}
                />
            )}
        </Box>
    );
};

const LogoAndTitle = ({ reportType }: { reportType: string }) => {
    const { t } = useTranslation();

    return (
        <Flex>
            <Logo
                checkTenantSettings
                lightColor={false}
                style={{
                    height: '50px',
                    marginBottom: '0',
                    marginRight: '24px',
                    width: 'auto'
                }}
                containerStyle={{
                    marginBottom: '0',
                    width: 'auto'
                }}
            />
            <Typography variant="h1">
                {t(`Reports.Title.${reportType}.report`)}
            </Typography>
        </Flex>
    );
};

const ReportHeader = ({
    startDate,
    endDate,
    reportType
}: {
    startDate: number;
    endDate: number;
    reportType: string;
}) => {
    const theme = useTheme();
    return (
        <Card
            sx={{
                border: 'none',
                boxShadow: theme.palette.reports.v2Header.boxShadow,
                marginBottom: '48px',
                padding: '24px 32px'
            }}
        >
            <Flex
                sx={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
                <LogoAndTitle reportType={reportType} />
                <ReportMeta startDate={startDate} endDate={endDate} />
            </Flex>
        </Card>
    );
};
export default ReportHeader;
